const PLACEHOLDER_PATTERN = /\{([^{}]+)\}|\[([^\]]+)\]/g;

export const hasResolvedValue = value =>
  value !== null &&
  value !== undefined &&
  !(typeof value === "string" && value.trim() === "");

/**
 * Resolves DATATABLE data-source placeholders without destroying unresolved
 * tokens. Both {field} and [field] are supported because existing screen
 * definitions use curly path placeholders and bracket query placeholders.
 */
export function resolveDataSource(template, values = {}) {
  const source = String(template || "");

  if (!source) {
    return { resolved: false, url: "", missingFields: [] };
  }

  const missingFields = [];
  const placeholders = [];

  for (const match of source.matchAll(PLACEHOLDER_PATTERN)) {
    const field = String(match[1] || match[2] || "").trim();
    if (field) placeholders.push(field);
  }

  for (const field of placeholders) {
    const exists = Object.prototype.hasOwnProperty.call(values || {}, field);
    if (!exists || !hasResolvedValue(values[field])) {
      if (!missingFields.includes(field)) missingFields.push(field);
    }
  }

  if (missingFields.length > 0) {
    return { resolved: false, url: "", missingFields };
  }

  const url = source.replace(
    PLACEHOLDER_PATTERN,
    (match, curlyField, bracketField) => {
      const field = String(curlyField || bracketField || "").trim();
      return encodeURIComponent(String(values[field]));
    }
  );

  return { resolved: true, url, missingFields: [] };
}

export function getUrlQueryValues(url, base) {
  if (!url) return {};

  try {
    const parsed = new URL(url, base);
    return Object.fromEntries(parsed.searchParams.entries());
  } catch (error) {
    return {};
  }
}

export function getEmbeddedTableRecords(recordData, tableName) {
  const containers = [];
  const data = recordData?.data;

  if (Array.isArray(data)) {
    data.forEach(entry => {
      if (Array.isArray(entry?.tablerecords)) containers.push(...entry.tablerecords);
    });
  } else if (Array.isArray(data?.tablerecords)) {
    containers.push(...data.tablerecords);
  }

  const table = containers.find(item => item?.sInputTableName === tableName);
  return Array.isArray(table?.tabledetails) ? table.tabledetails : [];
}
